export const pageTitle = 'Programs'
export const pageCaption = 'Follow a guided program to hit your fitness & wellness goals.'
